import 'bootstrap/dist/css/bootstrap.min.css'; 
import Navbar from './NavBar.js'
import '../assets/css/ProjectPageSection.css'
import Roll from 'react-reveal/Roll';


function ProjectPageSection(props) {
    return (
        <div className="sec9 container">
            {props.proname === 'Foodies' && <Navbar /> }
            <Roll right>
              <div className="row projectSection" style={{color:props.c1}}>
                <div className="col pros1">
                  <img src={props.url} alt="line"  />
                </div>
                <div className="col pros2">
                  <h2>{props.proname}</h2>
                  <p>{props.tech}</p>
                  {props.url2 !== '#' &&
                  <a href={props.url2}>
                    <button style={{backgroundColor:props.c1}}>
                        Source Code
                    </button>
                  </a>
                  }
                  {props.url3 !== '#' &&
                  <a href={props.url3}>
                    <button style={{backgroundColor:props.c1}}>
                        Live
                    </button>
                  </a>
                  }
                </div>   
              </div>
            </Roll>
            
          </div>
        );
    }
    
export default ProjectPageSection;